import { render, staticRenderFns } from "./AgentUser.vue?vue&type=template&id=5173a4d8&scoped=true&"
import script from "./AgentUser.vue?vue&type=script&lang=js&"
export * from "./AgentUser.vue?vue&type=script&lang=js&"
import style0 from "./AgentUser.vue?vue&type=style&index=0&id=5173a4d8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5173a4d8",
  null
  
)

export default component.exports